import { StyleSheet } from 'react-native-web';

import { brand } from '../../../../shared/colors-objects';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginHorizontal: 10,
    justifyContent: 'center',
  },
  buttonContainer: {
    width: 36,
    height: 36,
    display: 'flex',
    borderRadius: 18,
    alignItems: 'center',
    marginHorizontal: 6,
    justifyContent: 'center',
  },
  iconButton: {
    width: 24,
    height: 24,
  },
  textButton: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  hover: {
    backgroundColor: brand.lightTeal,
  },
  disabled: {
    cursor: 'not-allowed',
  },
});

export default styles;
